import Http from '../utilities/http';

export class VehicleRecallApi {
    static getRecall(query = {}) {
        return Http.get('/vehicle-recall', query);
    }
}
